import { create } from 'zustand';

interface AlignmentState {
  // Core alignment state
  alignmentMode: boolean;
  alignmentQueueId?: string;
  runRuleId?: string;

  // Dialog state
  isCreatingEvaluatorFromExperimentData: boolean;
  isCreateEvaluatorDialogOpen: boolean;

  // Actions
  setAlignmentMode: (value: boolean) => void;
  setAlignmentQueueId: (value?: string) => void;
  setRunRuleId: (value?: string) => void;
  setIsCreatingEvaluatorFromExperimentData: (value: boolean) => void;
  setIsCreateEvaluatorDialogOpen: (value: boolean) => void;

  // Utility actions
  resetAlignment: () => void;
}

export const useAlignmentStore = create<AlignmentState>((set) => ({
  // Initial state
  alignmentMode: false,
  alignmentQueueId: undefined,
  runRuleId: undefined,
  isCreatingEvaluatorFromExperimentData: false,
  isCreateEvaluatorDialogOpen: false,

  // Actions
  setAlignmentMode: (value) => set({ alignmentMode: value }),
  setAlignmentQueueId: (value) => set({ alignmentQueueId: value }),
  setRunRuleId: (value) => set({ runRuleId: value }),
  setIsCreatingEvaluatorFromExperimentData: (value) =>
    set({ isCreatingEvaluatorFromExperimentData: value }),
  setIsCreateEvaluatorDialogOpen: (value) =>
    set({ isCreateEvaluatorDialogOpen: value }),

  // Reset all alignment state
  resetAlignment: () =>
    set({
      alignmentMode: false,
      alignmentQueueId: undefined,
      runRuleId: undefined,
      isCreatingEvaluatorFromExperimentData: false,
      isCreateEvaluatorDialogOpen: false,
    }),
}));
